import { createContext, useContext } from "react"

export const SwContext = createContext({
    getPermission: async () => {
        return ""
    }
})

export function useSwContext() {
    return useContext(SwContext)
}
